<template>
  <button
    type="button"
    class="btn btn-tertiary border disabled:text-fp-gray-2 py-1 px-4 text-base flex gap-1 items-center text-fp-gray-5 rounded-md w-fit"
    v-bind="$attrs"
  >
    <ArrowLeftIcon
      :class="['h-3 w-3 text-fp-gray-5 mt-[1px]', extraIconClasses]"
    />
    {{ copy }}
  </button>
</template>

<script setup lang="ts">
import ArrowLeftIcon from '~/../member-webapp-shared/components/icons/figma/ArrowLeftIcon.vue'

defineProps({
  copy: {
    type: String,
    default: 'Back',
  },
  extraIconClasses: {
    type: String,
    default: '',
  },
})
</script>

<style scoped></style>
